<script setup>

import {store} from "@/store/store";
import 'animate.css';
import {onMounted, ref} from "vue";
import {animation_appear_first, animation_appear_in_game, word_highlight} from "@/js/animations";
const gameImg = ref(null);
const word = ref(null);

const isAnimationRunning = ref(true);

const advance = () => {
  isAnimationRunning.value = true;
  store.commit('advanceIndex');
  gameImg.value.classList.add(animation_appear_in_game);
  word.value.classList.add(word_highlight);
  setTimeout(() => {
    gameImg.value.classList.remove(animation_appear_in_game);
    word.value.classList.remove(word_highlight);
    isAnimationRunning.value = false;
  }, 800);
}

onMounted(() => {
  setTimeout(() => {
    gameImg.value.classList.remove(animation_appear_first);
    isAnimationRunning.value = false;
  }, 1000);
})

</script>

<template>
  <div ref="word" class="font-bold text-5xl animate__animated mt-2 text-center text-black-900 my-4">
    {{ store.getters.currentWord }}
  </div>
  <div class="flex justify-center">
    <img
        ref="gameImg"
        class="game-img object-contain animate__animated animate__fast"
        :class="animation_appear_first"
        :src="store.getters.currentImgSrc"
        alt="">
  </div>
  <div class="flex justify-stretch mt-6 p-2">
    <button
        :disabled="isAnimationRunning"
        class="btn btn-outline flex-shrink-0 text-neutral-content" @click="store.commit('prevIndex')">
      ←
    </button>
    <button
        :disabled="isAnimationRunning"
        class="btn btn-outline flex-grow ml-1 text-neutral-content" @click="advance">
      →
    </button>
  </div>
</template>

<style scoped>
.game-img {
  width: 100%;
  max-height: 70vh;
}
</style>